import Vue from "vue";
import { Confirm, ConfirmResult } from "./classes/confirm";
import { Dialog } from "./classes/dialog";
import { WfNotification } from "./classes/notification";
import eventBus from "./event-bus";
import { getParentsWithClassCount } from "./utils/dom";

const XS_MAX_WIDTH = 575;
const SM_MAX_WIDTH = 768;
const MD_MAX_WIDTH = 991;
const LG_MAX_WIDTH = 1199;

export const wfVueExtensionsVars = {
	modalDepth: 0,
};

export default class WfVueExtensions {
	width:number = 0;
	height:number = 0;
	isXs:boolean = false;
	isSm:boolean = false;
	isMd:boolean = false;
	isLg:boolean = false;
	isXl:boolean = false;
	isSmDown:boolean = false;
	isMdDown:boolean = false;
	isLgDown:boolean = false;
	isSmUp:boolean = false;
	isMdUp:boolean = false;
	isLgUp:boolean = false;

	constructor() {
		this.width = window.innerWidth;
		this.height = window.innerHeight;
		this.computeSizes();

		eventBus.$on("window-resize", (data:{width:number, height:number}) => {
			this.width = data.width;
			this.height = data.height;
			this.computeSizes();
		});
	}

	dialog(text:any, buttonText:any, title?:any, className?:any):Promise<any> {
		let d = new Dialog();
		d.text = text;
		d.title = title;
		d.buttonText = buttonText;
		d.className = className;
		eventBus.$emit("dialog", d);
		let promise = new Promise(function(resolve) {
			d.onDismis = resolve;
		});
		return promise;
	}

	confirm(text:any, yesButtonText:any, noButtonText:any, title?:any, className?:any, cancelButtonText?:any):Promise<ConfirmResult> {
		let c = new Confirm();
		c.text = text;
		c.yesText = yesButtonText;
		c.noText = noButtonText;
		c.cancelText = cancelButtonText;
		c.title = title;
		c.className = className;
		eventBus.$emit("confirm", c);
		let promise = new Promise<ConfirmResult>(function(resolve) {
			c.onDismiss = resolve;
		});
		return promise;
	}

	notify(text:any, classes:any = "", duration:number = 3000, icon?:string) {
		let notification = new WfNotification();
		notification.text = text;
		notification.classes = classes;
		notification.duration = duration;
		notification.icon = icon;
		eventBus.$emit("notification", notification);
	}

	private computeSizes() {
		this.isSmDown = this.width <= SM_MAX_WIDTH;
		this.isMdDown = this.width <= MD_MAX_WIDTH;
		this.isLgDown = this.width <= LG_MAX_WIDTH;
		this.isSmUp = this.width > XS_MAX_WIDTH;
		this.isMdUp = this.width > SM_MAX_WIDTH;
		this.isLgUp = this.width > MD_MAX_WIDTH;
		this.isXs = this.width <= XS_MAX_WIDTH;
		this.isSm = this.width <= SM_MAX_WIDTH && !this.isXs;
		this.isMd = this.width <= MD_MAX_WIDTH && !this.isSmDown;
		this.isLg = this.width <= LG_MAX_WIDTH && !this.isMdDown;
		this.isXl = this.width > LG_MAX_WIDTH;
	}

	public isModalOpen(el:Vue):boolean {
		if (!el.$el) return false;
		let count = getParentsWithClassCount(el.$el as HTMLElement, "w-modal");
		return wfVueExtensionsVars.modalDepth > count;
	}
}